import { observer } from 'mobx-react-lite';

import {
  IEUBusinessesQueryVariables,
  useEuropeBusinessesQuery,
} from './eu-businesses-query';
import { SecondaryMarketTable } from './secondary-market-table';
import { SecondaryMarketTableLoader } from './secondary-market-table-loader';
import { businessDataFromEURecord } from './utils';

export interface ISecondaryMarketDealsProps {
  limit?: number;
  sort?: IEUBusinessesQueryVariables['sort'];
}

export const SecondaryMarketDeals = observer(function SecondaryMarketDeals({
  limit = 8,
  sort = 'performance_desc',
}: ISecondaryMarketDealsProps) {
  const businessesQuery = useEuropeBusinessesQuery({
    per_page: limit,
    page_size: limit,
    sort,
  });

  const deals = businessesQuery?.value?.result?.map((business) =>
    businessDataFromEURecord(business)
  );

  if (businessesQuery?.state === 'pending') {
    return <SecondaryMarketTableLoader limit={limit} />;
  }

  if (!deals?.length) return null;

  return <SecondaryMarketTable deals={deals} />;
});
